<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="d-flex flex-column">
        <div class="text-right mb-3"></div>
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Record Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template #cell(index)="row">
              <span> {{ row.index + 1 }} </span>
            </template>

            <template v-slot:cell(denominazioneStruttura)="{ item }">
              <span>({{ item.codiceStruttura }}) {{ item.denominazioneStruttura }} </span>
            </template>

            <!-- <template v-slot:cell(documentiCollegati)>
              <strong>1</strong>
            </template> -->

            <template v-slot:cell(actions)="row">
              <b-container class="bv-example-row">
                <b-button size="sm" v-b-tooltip.hover title="Modifica Causale Documento" variant="outline-success" @click="onClickEditCausaleTipoDocumento(row.item)">
                  <font-awesome-icon icon="edit"> </font-awesome-icon>
                </b-button>
                <b-button size="sm" v-b-tooltip.hover title="Cancella Causale Documento" variant="outline-danger" @click="onClickDeleteCausaleDocumento(row.item)" class="mr-1 no-text">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
      </div>
      <div class="sa-list-component-footer">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  mixins: [UtilityMixin],
  data() {
    return {
      rows: 0,
      perPage: 50,
      currentPage: 1,
      pathResource: "/contabilitadocumentocausali",
      showModalLoading: false,
      listKey: 0,
      filtro: {},
      items: [],
      fields: [
        {
          label: "*",
          key: "index",
          thStyle: "width: 4rem",
        },
        {
          label: "Codice",
          key: "codiceTipoDocumento",
          sortable: true,
          thStyle: "width: 8rem",
        },
        {
          label: "Struttura",
          key: "denominazioneStruttura",
          sortable: true,
        },

        {
          label: "Tipo Documento",
          key: "descrizioneTipoDocumento",
          sortable: true,
        },
        {
          label: "Causale",
          key: "descrizioneCausale",
          sortable: true,
        },
        // {
        //   label: "Documenti Collegati",
        //   key: "documentiCollegati",
        //   sortable: true,
        // },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
    };
  },
  mounted() {
    let me = this;
    me.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      me.openShowModalLoading();
      me.$emit("beforeLoadData");
      let sessionStorage = window.sessionStorage;
      if (sessionStorage["filtroTipiDocumentoCausali"]) {
        me.filtro = JSON.parse(sessionStorage["filtroTipiDocumentoCausali"]);
        me.$emit("updateFilter", me.filtro);
      }
      me.filtro.page = me.currentPage;
      me.filtro.forPage = me.perPage;
      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.closeShowModalLoading();
      me.$emit("afterLoadData");
    },
    loadDataError(error) {
      let me = this;
      console.error("Errore durante il caricamento dei dati:", error);
      me.items = [];
      me.rows = 0;
      me.closeShowModalLoading();
      me.$emit("afterLoadData");
    },
    onClickEditCausaleTipoDocumento(item) {
      this.$emit("editCausaleDocumento", item);
    },
    onClickDeleteCausaleDocumento(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questa causale '" + item.descrizioneCausale + "'?", {
          title: "Eliminazione Causale Documento",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteDocumentoCausale(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteDocumentoCausale(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteDocumentoCausaleSuccess, me.deleteDocumentoCausaleError);
    },
    deleteDocumentoCausaleSuccess(response) {
      let me = this;
      response;
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
      me.loadData();
    },
    deleteDocumentoCausaleError() {
      let me = this;
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>

<style></style>
